import { Box, IconButton } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import InfoTooltip from '@/components/InfoTooltip/InfoTooltip';

export default function PublicKeyInput({
  value,
  labelKey,
  helperKey,
  placeholderKey,
  toastKey,
  inputId,
}) {
  const { t } = useTranslation();

  const handleCopy = () => {
    navigator.clipboard.writeText(value).then(
      () => {
        toast.success(t(toastKey));
      },
      () => {
        toast.error(t('common.copyToClipboardFailed'));
      },
    );
  };

  return (
    <Box sx={{ mb: 2.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Box
          component='label'
          htmlFor={inputId}
          sx={{ fontWeight: 400, color: 'text.primary', mr: 1.25 }}>
          {t(labelKey)}
        </Box>
        <InfoTooltip title={t(helperKey)} placement='top' />
        {value && (
          <IconButton
            onClick={handleCopy}
            color='primary'
            size='small'
            title={t('common.copyToClipboard')}
            sx={{ ml: '5px' }}>
            <ContentCopy fontSize='small' />
          </IconButton>
        )}
      </Box>
      <Box
        component='textarea'
        id={inputId}
        name={inputId}
        value={value || ''}
        disabled
        placeholder={t(placeholderKey)}
        sx={{
          width: '100%',
          minHeight: '120px',
          p: 1.5,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          fontFamily: 'monospace',
          fontSize: '0.875rem',
          resize: 'vertical',
          boxSizing: 'border-box',
          bgcolor: 'action.disabledBackground',
          cursor: 'not-allowed',
        }}
      />
    </Box>
  );
}
